export enum AIRequestType {
  GeneralQuery = 'generalQuery',
  TextSummarize = 'textSummarize',
  PdfSummary = 'pdfSummary',
  ImageAnalysis = 'imageAnalysis',
}

export enum AIMessageRole {
  User = 'user',
  Bot = 'bot',
}

export enum AISuggestionType {
  ImageAnalysis = 'imageAnalysis',
  GeneralQuery = 'generalQuery',
}

export enum AIAgentId {
  DefaultAgent = 'default-agent',
  PdfAgent = 'pdf-agent',
  NavigationAgent = 'navigation-agent',
}


